import { HTMLAttributes } from "react";
import styled from "styled-components";

const Styled = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    gap: 8px;

    .title {
        align-items: flex-start;
        cursor: default;
        display: flex;
        flex-direction: column;
        gap: 2px;
        white-space: nowrap;

        span {
            display: block;
            font-size: .8rem;
            line-height: .9;

            &:empty {
                display: none;
            }

            &:not(:first-of-type) {
                opacity: .6;
            }
        }
    }
`;

interface ILanguageLabelProps {
    subtitle?: string
    title: string
}

export default function LocaleCard(props: ILanguageLabelProps & HTMLAttributes<HTMLDivElement>) {
    const { children, subtitle, title, ...restProps } = props;
    return (
        <Styled { ...restProps }>
            { children }
            <div className="title">
                <span>{ title }</span>
                <span>{ subtitle }</span>
            </div>
        </Styled>
    );
}
